import { render } from "./App.vue?vue&type=template&id=2290b034"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2290b034&lang=scss"

import exportComponent from "D:\\0_Winth\\Yangbang source code\\20221221\\yb_web_new_01\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__